module.exports = __webpack_public_path__ + "img/ranking_example.e09c8c36.png";